import React, { useCallback, useState } from 'react'
import { useLocationContext } from '../../../../contexts/location.context'
import { SummaryShippingTo, SummaryShippingToLocation } from './SummaryWmo.css'
import SummaryShippingModal from './SummaryShippingModal'

const SummaryShippingSelector: React.FC = () => {
  const locationData = useLocationContext()
  const [isModalOpen, setModalOpen] = useState(false)

  const {
    postalCode, city, state,
  } = locationData

  const storedPostalCode = localStorage.getItem('postalCode')
  const updateEvent = new Event('postalCode')
  if (window && typeof storedPostalCode !== 'undefined' &&
    storedPostalCode?.toString() !== postalCode?.toString()) {
      localStorage.setItem('postalCode', postalCode)
      window.dispatchEvent(updateEvent)
  }

  const openLocationModal = useCallback(() => {
    setModalOpen(true)
  }, [])

  if (!locationData) {
    return null
  }

  return (
    <>
      <SummaryShippingTo>
        {'Shipping to: '}
        <SummaryShippingToLocation onClick={openLocationModal}>
          <span translate="no">{`${city}, ${state} ${postalCode}`}</span>
        </SummaryShippingToLocation>
      </SummaryShippingTo>
      <SummaryShippingModal open={isModalOpen} onOpenChange={setModalOpen} city={city} zipcode={postalCode} />
    </>
  )
}

export default SummaryShippingSelector
